import script from "./HrDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./HrDrawer.vue?vue&type=script&setup=true&lang=js"

import "./HrDrawer.vue?vue&type=style&index=0&id=7826c311&lang=css"

const __exports__ = script;

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer});
